<div class="hz-content lr" style="{{style}}">
  <div class="hz-icon-main lr" hz-click="{this.goto($event)}">
    <img class="hz-icon" src={{icon}} alt="" />
  </div>
  <div class="hz-title">{{title}}</div>
</div>
